import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../api/axiosBaseQuery";

export const roleReviewApi = createApi({
  reducerPath: "roleReviewApi",
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    // Create a new role review
    createRoleReview: builder.mutation({
      query: (data) => ({
        url: "roleReview/role-review",
        method: "POST",
        data,
      }),
    }),

    // Fetch role reviews by employee ID
    fetchRoleReviewsByEmployee: builder.query({
      query: (employeeId) => ({
        url: `roleReview/role-review/${employeeId}`,
        method: "GET",
      }),
    }),

    // Update an existing role review
    updateRoleReview: builder.mutation({
      query: ({ reviewId, data }) => ({
        url: `roleReview/role-review/${reviewId}`,
        method: "PUT",
        data,
      }),
    }),

    // Fetch core focus areas
    fetchCoreFocusAreas: builder.query({
      query: (userId) => ({
        url: `coreFocusArea/core_focus_areas/${userId}`,
        method: "GET",
      }),
    }),

    // Create a core focus area
    createCoreFocusArea: builder.mutation({
      query: (data) => ({
        url: "coreFocusArea/core_focus_areas/",
        method: "POST",
        data,
      }),
    }),

    // Update a core focus area
    updateCoreFocusArea: builder.mutation({
      query: ({ id, data }) => ({
        url: `coreFocusArea/core_focus_areas/${id}`,
        method: "PUT",
        data,
      }),
    }),
    criticalActivities: builder.mutation({
      query: (data) => ({
        url: "criticalactivities/critical_activities/",
        method: "POST",
        data,
      }),
    }),
    fetchTime: builder.query({
      query: (employeeId) => ({
        url: `coreFocusArea/core_focus_areas/time_spent/${employeeId}`,
        method: "GET",
      }),
    }),
    fetchImportance: builder.query({
      query: (employeeId) => ({
        url: `coreFocusArea/core_focus_areas/importance/${employeeId}`,
        method: "GET",
      }),
    }),
    fetchCoreActivities: builder.query({
      query: (employeeId) => ({
        url: `criticalactivities/user_details/${employeeId}`,
        method: "GET",
      }),
      providesTags: ['CoreActivities'],
    }),
    fetchCoreActivity: builder.query({
      query: (employeeId) => ({
        url: `criticalactivities/critical_activities/user/${employeeId}`,
        method: "GET",
      }),
    }),
    addWorkdata: builder.mutation({
      query: (data) => ({
        url: "roleReview/submit-work",
        method: "POST",
        data,
      }),
    }),
    getWorkdata: builder.query({
      query: (employeeId) => ({
        url: `roleReview/get-work/${employeeId}`,
        method: "GET",
      }),
    }),
    renameCoreFocusArea: builder.mutation({
      query: (data) => ({
        url: `coreFocusArea/core_focus_areas/rename`,
        method: "PUT",
        data,
      }),
      invalidatesTags: ['CoreActivities']
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useCreateRoleReviewMutation,
  useFetchRoleReviewsByEmployeeQuery,
  useUpdateRoleReviewMutation,
  useFetchCoreFocusAreasQuery,
  useCreateCoreFocusAreaMutation,
  useUpdateCoreFocusAreaMutation,
  useCriticalActivitiesMutation,
  useFetchTimeQuery,
  useFetchImportanceQuery,
  useFetchCoreActivityQuery,
  useFetchCoreActivitiesQuery,
  useAddWorkdataMutation,
  useGetWorkdataQuery,
  useRenameCoreFocusAreaMutation,
} = roleReviewApi;

export default roleReviewApi;
